import React, { useCallback, useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { XIcon, GiftIcon, CheckCircle2Icon, AlertTriangleIcon } from 'lucide-react';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const handleMouseLeave = useCallback((e: MouseEvent) => {
    if (e.clientY <= 0 && !hasShown) {
      setIsVisible(true);
      setHasShown(true);
    }
  }, [hasShown]);
  useEffect(() => {
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [handleMouseLeave]);
  useEffect(() => {
    if (!isVisible) return;
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsVisible(false);
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-[110] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Oferta especial antes de irte" data-id="element-1">
      <div className="absolute inset-0 bg-black/70 animate-[fadeIn_200ms_ease-out]" onClick={() => setIsVisible(false)} data-id="element-2" />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-[slideUp_300ms_ease-out]" data-id="element-3">
        {/* Urgency Banner */}
        <div className="bg-gradient-to-r from-red-600 to-amber-600 px-6 py-3 flex items-center justify-center gap-2" data-id="element-4">
          <AlertTriangleIcon className="h-5 w-5 text-white animate-pulse" data-id="element-5" />
          <span className="text-white font-bold text-sm uppercase tracking-wide" data-id="element-6">
            Oferta exclusiva — Solo ahora
          </span>
          <AlertTriangleIcon className="h-5 w-5 text-white animate-pulse" data-id="element-7" />
        </div>

        {/* Close Button */}
        <button onClick={() => setIsVisible(false)} className="absolute top-14 right-4 h-8 w-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors text-gray-500 z-10" aria-label="Cerrar" data-id="element-8">
          <XIcon className="h-4 w-4" data-id="element-9" />
        </button>

        <div className="p-6 md:p-8" data-id="element-10">
          {/* Icon */}
          <div className="flex justify-center mb-4" data-id="element-11">
            <div className="h-16 w-16 bg-amber-100 rounded-full flex items-center justify-center" data-id="element-12">
              <GiftIcon className="h-8 w-8 text-amber-600" data-id="element-13" />
            </div>
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-2" data-id="element-14">
            ¡Espera! No te vayas sin esta oferta exclusiva
          </h3>
          <p className="text-gray-500 text-center mb-6" data-id="element-15">
            Sabemos que tomar decisiones importantes requiere tiempo. Por eso,
            te damos un descuento adicional solo por hoy.
          </p>

          {/* Value Stack */}
          <div className="bg-gray-50 rounded-xl p-5 mb-6 space-y-3" data-id="element-16">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3" data-id="element-17">
              Todo lo que recibes:
            </p>
            <div className="flex items-center gap-3" data-id="element-18">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-19" />
              <span className="text-gray-700 text-sm" data-id="element-20">
                Framework RELAB completo
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-21">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-22" />
              <span className="text-gray-700 text-sm" data-id="element-23">
                Inteligencia de Mercado Colombia
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-24">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-25" />
              <span className="text-gray-700 text-sm" data-id="element-26">
                El Guion de Hierro (scripts exactos)
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-27">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-28" />
              <span className="text-gray-700 text-sm" data-id="element-29">
                Plan de Salida estratégico
              </span>
            </div>
          </div>

          {/* Pricing */}
          <div className="text-center mb-6" data-id="element-30">
            <div className="flex items-center justify-center gap-3 mb-1" data-id="element-31">
              <span className="text-lg text-gray-400 line-through" data-id="element-32">
                $19.900
              </span>
              <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-1 rounded-full" data-id="element-33">
                -35% DESCUENTO EXTRA
              </span>
            </div>
            <div className="flex items-baseline justify-center gap-1" data-id="element-34">
              <span className="text-5xl font-bold text-emerald-900" data-id="element-35">
                $12.900
              </span>
              <span className="text-lg text-gray-500" data-id="element-36">COP</span>
            </div>
            <p className="text-gray-400 text-sm mt-1" data-id="element-37">
              Precio final. Sin cargos ocultos.
            </p>
          </div>

          {/* CTA */}
          <Button variant="accent" size="lg" className="w-full text-base py-5 shadow-xl shadow-amber-600/25" onClick={() => window.open('https://mapaclaro.com/cart/52360055849249:1', '_blank')} data-id="element-38">
            APROVECHAR OFERTA ESPECIAL
          </Button>

          <button onClick={() => setIsVisible(false)} className="w-full mt-3 py-2 text-sm text-gray-400 hover:text-gray-600 transition-colors" data-id="element-39">
            No, prefiero pagar el precio completo
          </button>
        </div>
      </div>
    </div>;
}